import { __generator } from "tslib";
import { take, call, put, select } from 'redux-saga/effects';
import { changeCurrentMediaSource, setCurrentFolderId, fetchMoreGallections, fetchMoreGallectionsDone, reloadStashStreamDone, } from '../actions';
import { STREAM__WITH_OFFSET__FETCH_SUCCESS } from '../../Stream/withOffset/actions';
import { getCurrentMediaSource, getGallections } from '../selectors';
import { getGallectionDeviationStreamId } from '../helpers';
import { withOffset } from '../../Stream';
import { MediaSourceType } from '../types';
function getOrLoadGallections() {
    var gallections, done, payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getGallections)];
            case 1:
                gallections = _a.sent();
                if (!(!gallections || gallections.length === 0)) return [3 /*break*/, 7];
                // gallections for the currentMediaSource have not yet been loaded, load them
                return [4 /*yield*/, put(fetchMoreGallections())];
            case 2:
                // gallections for the currentMediaSource have not yet been loaded, load them
                _a.sent();
                done = false;
                _a.label = 3;
            case 3:
                if (!!done) return [3 /*break*/, 5];
                return [4 /*yield*/, take(fetchMoreGallectionsDone)];
            case 4:
                payload = (_a.sent()).payload;
                done = (payload === null || payload === void 0 ? void 0 : payload.type) === MediaSourceType.STASH;
                return [3 /*break*/, 3];
            case 5: return [4 /*yield*/, select(getGallections)];
            case 6:
                gallections = _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/, gallections];
        }
    });
}
export function reloadStashStream() {
    var currentMediaSource, gallections, currentFolderId, streamId, done, actionStreamId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                currentMediaSource = _a.sent();
                if (!(currentMediaSource !== MediaSourceType.STASH)) return [3 /*break*/, 3];
                // change the media source to stash
                return [4 /*yield*/, put(changeCurrentMediaSource(MediaSourceType.STASH))];
            case 2:
                // change the media source to stash
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, call(getOrLoadGallections)];
            case 4:
                gallections = _a.sent();
                if (!!gallections.length) return [3 /*break*/, 6];
                // still no folders? everything is terrible, let's crash gracefully
                return [4 /*yield*/, put(reloadStashStreamDone())];
            case 5:
                // still no folders? everything is terrible, let's crash gracefully
                _a.sent();
                return [2 /*return*/];
            case 6:
                currentFolderId = gallections[0].folderId;
                streamId = getGallectionDeviationStreamId(MediaSourceType.STASH, currentFolderId);
                return [4 /*yield*/, put(withOffset.actions.deleteStream(streamId))];
            case 7:
                _a.sent();
                // Load this folder id
                return [4 /*yield*/, put(setCurrentFolderId(gallections[0].folderId))];
            case 8:
                // Load this folder id
                _a.sent();
                done = false;
                _a.label = 9;
            case 9:
                if (!!done) return [3 /*break*/, 11];
                return [4 /*yield*/, take(STREAM__WITH_OFFSET__FETCH_SUCCESS)];
            case 10:
                actionStreamId = (_a.sent()).streamId;
                done = actionStreamId === streamId;
                return [3 /*break*/, 9];
            case 11: return [4 /*yield*/, put(reloadStashStreamDone())];
            case 12:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default reloadStashStream;
//# sourceMappingURL=reloadStashStream.js.map